module.exports = __webpack_public_path__ + "img/myeduEXAMSS.656ccc17.png";